export const calculateInsolation = (insolation: number) => {
  const date = new Date(0, 0);
  date.setMinutes(+insolation.toString() * 60);
  let result = date.toTimeString().slice(0, 5);
  if (result.substring(0, 2) === '00') {
    result = `0${result.replace(/^0+/, '')}`;
  } else {
    result = result.replace(/^0+/, '');
  }

  return `${result}h`;
};
